module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>"